import { logout } from "../../services/auth/msal";
import { useLoginState } from "../../hooks/useLoginState";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { Menu } from "./Menu";
import { Logo } from "./Logo";
import { Items } from "./Items";
import { AppName } from "./AppName";

const pathTitles = {
  "/projects": "Performance",
  "/inventory-management": "Inventory Management",
};

const Topbar = () =>
{
  const {currentUser} = useLoginState();
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    if (location.pathname === '/') return 'Store';
    if (pathTitles[location.pathname]) return pathTitles[location.pathname];
    if (location.pathname.startsWith('/inventory-management')) return 'Inventory Management';
    return 'Performance';
  };

  useEffect(() => {
    const title = location.pathname === '/' ? 'ETRO Store' : getPageTitle();
    document.title = title;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className="mb-6 flex py-[20px] pl-[48px] mr-[24px] border-b border-[#DBDBE0]">
      <div className="flex items-center gap-[22px]">
        <Menu/>
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}><Logo/></div>
        <AppName title={getPageTitle()} />
      </div>
      <div className="ml-auto flex items-center gap-4">
        <Items user={currentUser} logout={logout}/>
      </div>
    </div>
  );
};

export default Topbar;
